<template>
  <ErrorPage>
    疑似账号异常，无法参与此活动
  </ErrorPage>
</template>

<script>
import ErrorPage from '@/components/templates/common/ErrorPage';

export default {
  components: { ErrorPage }
};
</script>

<style></style>
